import axios from 'axios';

const BASE = '/api/v2/kirami';

/**
 * @typedef {Object} SupportTicketRequest
 * @property {string} name
 * @property {string} email
 * @property {string} message
 */

const chatApi = {
  /**
   * @param {object} newChatRequest
   * @param {string} newChatRequest.name
   * @param {string} newChatRequest.locale
   * @returns {Promise<{id: string, name: string, locale: string}>}
   */
  async newChat(newChatRequest) {
    const response = await axios.post(`${BASE}/chat`, newChatRequest);
    return response.data;
  },
  /**
   * SSE-streamin URL; fetchEventSource ohittaa axiosin, joten baseURL liitetään käsin.
   */
  streamUrl(chatId) {
    const baseURL = axios.defaults.baseURL || '';
    return `${baseURL}${BASE}/chat/${chatId}/message-stream`;
  },
  async rating(message, rating) {
    const url = `${BASE}/chat/${message.chatId}/message/${message.originalId}/rating/${rating}`;
    const response = await axios.post(url, null);
    return response.data.response;
  },
  /**
   * @param object message
   * @param {SupportTicketRequest} supportTicketRequest
   * @returns {Promise<{ok: boolean, serial_number: string|null}>}
   */
  async postSupportTicket(message, supportTicketRequest) {
    const url = `${BASE}/chat/${message.chatId}/message/${message.originalId}/support_request`;
    const response = await axios.post(url, supportTicketRequest);
    return response.data.response;
  },
};

export default chatApi;
